import React, { useState, useEffect, useRef } from 'react';

const SmartAIMenu = ({ isOpen, onClose, onSmartAIChange, initialSettings }) => {
  const [settings, setSettings] = useState({
    multipleResponses: false,
    promptAutoImprove: false,
    industry: '',
    trait: '',
    role: '',
    memory: 'Full'  // Default to Full memory
  });
  
  // Use a ref to track if we've initialized from props
  const initializedRef = useRef(false);
  
  // Only initialize from props once
  useEffect(() => {
    if (initialSettings && !initializedRef.current) {
      setSettings(prev => ({
        ...prev,
        ...initialSettings
      }));
      initializedRef.current = true;
    }
  }, [initialSettings]);

  // Use a ref to prevent continuous updates
  const settingsRef = useRef(settings);
  
  // Update the ref when settings change
  useEffect(() => {
    settingsRef.current = settings;
  }, [settings]);
  
  // Debounce the settings changes to parent
  useEffect(() => {
    if (!onSmartAIChange) return;
    
    const timer = setTimeout(() => {
      onSmartAIChange(settingsRef.current);
    }, 300); // 300ms debounce
    
    return () => clearTimeout(timer);
  }, [settings, onSmartAIChange]);

  const handleSettingChange = (name, value) => {
    console.log(`Setting ${name} to ${value}`);
    setSettings(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const traits = [
    "Concise & Direct",
    "Casual & Friendly",
    "Formal & Professional"
  ];

  const roles = ["Default", "Expert", "Teacher", "Friend", "Programmer"];
  const memoryOptions = ["Full", "Short", "None"];

  if (!isOpen) return null;

  return (
    <div className="cockpit-menu smart-ai-menu" style={{ display: "flex", flexWrap: "wrap", gap: "25px" }}>
      <div className="smart-ai-option" style={{ flex: "0 0 auto" }}>
        <label className="toggle-label">
          <span>Multiple responses</span>
          <div className="toggle-switch">
            <input 
              type="checkbox" 
              className="toggle-input" 
              checked={settings.multipleResponses}
              onChange={(e) => handleSettingChange('multipleResponses', e.target.checked)}
            />
            <span className="toggle-slider"></span>
          </div>
        </label>
      </div>

      <div className="smart-ai-option" style={{ flex: "0 0 auto" }}>
        <input 
          type="text" 
          className="text-input"
          placeholder="Industry" 
          value={settings.industry}
          onChange={(e) => handleSettingChange('industry', e.target.value)}
          style={{ width: "140px" }}
        />
      </div>

      <div className="smart-ai-option" style={{ flex: "0 0 auto" }}>
        <select 
          className="select-input"
          value={settings.trait}
          onChange={(e) => handleSettingChange('trait', e.target.value)}
          style={{ width: "140px" }}
        >
          <option value="">Trait</option>
          {traits.map((trait, index) => (
            <option key={index} value={trait}>{trait}</option>
          ))}
        </select>
      </div>

      <div className="smart-ai-option" style={{ flex: "0 0 auto" }}>
        <select 
          className="select-input"
          value={settings.role}
          onChange={(e) => handleSettingChange('role', e.target.value)}
          style={{ width: "120px" }}
        >
          <option value="">Role</option>
          {roles.map((role, index) => (
            <option key={index} value={role}>{role}</option>
          ))}
        </select>
      </div>
      
      <div className="smart-ai-option" style={{ flex: "0 0 auto" }}>
        <span className="memory-label" style={{ fontSize: "13px" }}>Memory: </span>
        <div className="slider-container" style={{ minWidth: "unset" }}>
          {memoryOptions.map((option, index) => (
            <label key={index} className="memory-option">
              <input
                type="radio"
                name="memory"
                value={option}
                checked={settings.memory === option}
                onChange={(e) => handleSettingChange('memory', e.target.value)}
              />
              <span style={{ fontSize: "14px", padding: "11px" }}>{option}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SmartAIMenu; 